import React from 'react';

import {
  NotFoundMetaDataContainer,
} from '../../containers/NotFoundMetaDataContainer/NotFoundMetaDataContainer';
import { NotFoundPageBody } from '../NotFoundPageBody/NotFoundPageBody';

export const NotFoundPage = () => (
  <>
    <NotFoundMetaDataContainer />
    <NotFoundPageBody />
  </>
);

export default NotFoundPage;
